import { extractStringValueSet } from './extract-properties';

export default class ExternalReferenceLabTestNames {
    /* eslint-disable camelcase */
    static readonly HER2_IHC: string = 'HER2 IHC';
    static readonly HER2_FISH: string = 'HER2 FISH';
    static readonly TempusMerlin: string = 'Tempus Merlin';
    static readonly xT_CDx: string = 'xT CDx';
    static readonly CANCERNEXT: string = 'xG (CancerNext)';
    static readonly CANCERNEXT_RNAINSIGHT: string = 'xG (CancerNext) +RNAinsight';
    static readonly CANCERNEXT_EXPANDED: string = 'xG+ (CancerNext-Expanded)';
    static readonly CANCERNEXT_EXPANDED_RNAINSIGHT: string = 'xG+ (CancerNext-Expanded) +RNAinsight';
    static readonly SSA: string = 'SSA (Single Site Analysis)';
    static readonly FOLR1_IHC: string = 'FOLR1 IHC';
    static readonly FAMILIAL_VARIANT_TESTING: string = 'Familial Variant Testing';
    static readonly ONE_P_19Q_FISH: string = '1p19q FISH';
    static readonly MGMT_METHYLATION: string = 'MGMT Methylation';
    static readonly PD_L1_22C3_IHC_FDA: string = 'PD-L1 22C3 IHC FDA';
    static readonly xM_NeXT_PERSONAL_DX: string = 'xM (NeXT Personal Dx)';
    static readonly CLAUDIN_18_IHC_FDA: string = 'Claudin 18 IHC FDA';

    private static _valueSet: Set<string> = null;
    static get values(): Set<string> {
        if (!this._valueSet) {
            this._valueSet = new Set();
            this._valueSet = extractStringValueSet(this);
        }

        return new Set(this._valueSet);
    }
}
